import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface UserAccountResource
    extends ng.resource.IResourceClass<ng.resource.IResource<UserAccountDto>> {
    changeTrackingSettings: ng.resource.IResourceMethod<
        ng.resource.IResource<UserAccountDto>
    >;
}

function userAccountResource(
    $resource: ng.resource.IResourceService
): UserAccountResource {
    return <UserAccountResource>$resource(
        config.monolithApi + '/user-account/:id',
        { id: '@id' },
        {
            changeTrackingSettings: {
                url:
                    config.monolithApi +
                    '/user-account/change-tracking-settings',
                method: 'PUT'
            }
        }
    );
}

angular.module('app').factory('userAccountResource', userAccountResource);
